// extracted by mini-css-extract-plugin
export default {"business_account_container":"BusinessNewAccount_business_account_container__2UKuL","bottom_button_inner_container":"BusinessNewAccount_bottom_button_inner_container__ykrlu"};